import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail, CheckCircle, Loader2 } from "lucide-react";

export default function EmailCapture({ source = "homepage" }) {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    const { base44 } = await import("@/api/base44Client");
    await base44.entities.EmailSubscriber.create({ email, source });
    setSubmitted(true);
    setLoading(false);
  };

  return (
    <section className="bg-foreground text-background py-16 lg:py-20">
      <div className="max-w-2xl mx-auto px-4 text-center">
        <div className="w-14 h-14 rounded-2xl bg-accent/20 flex items-center justify-center mx-auto mb-6">
          <Mail className="w-7 h-7 text-accent" />
        </div>

        <h2 className="font-heading font-bold text-2xl lg:text-3xl mb-3">
          Get the Free Solar Panel Sizing Checklist
        </h2>
        <p className="text-background/60 mb-8 max-w-lg mx-auto">
          Enter your email and get a simple checklist to help choose the right solar panel wattage, panel type, and setup for your RV, cabin, camping gear, or backup power system.
        </p>

        {submitted ? (
          <div className="flex items-center justify-center gap-3 bg-accent/20 rounded-xl py-4 px-6">
            <CheckCircle className="w-5 h-5 text-accent" />
            <p className="font-medium">Check your inbox! The checklist is on its way.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <Input
              type="email"
              placeholder="you@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="flex-1 bg-background/10 border-background/20 text-background placeholder:text-background/40 h-12"
            />
            <Button
              type="submit"
              disabled={loading}
              className="bg-accent text-foreground hover:bg-accent/90 font-mono font-bold h-12 px-6 min-w-[180px]"
            >
              {loading ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                "Send Me the Checklist"
              )}
            </Button>
          </form>
        )}
      </div>
    </section>
  );
}